import type { LeaveTypesRepositoryT } from "screens/Vacations/components/LeaveTypes/domain/ports/leaveTypes.repository";
import type { LeaveTypeEntityT } from "screens/Vacations/components/LeaveTypes/domain/entities/leaveType.entity";

type GetVacationPolicyParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  colaboraInstanceId: string;
};

export const getVacationPolicy = async ({
  leaveTypesRepository,
  colaboraInstanceId,
}: GetVacationPolicyParamsT): Promise<LeaveTypeEntityT> => {
  const types = await leaveTypesRepository.getAll(
    colaboraInstanceId,
    "VACATION",
  );

  const vacationType = types[0];

  if (!vacationType)
    throw new Error("La empresa no cuenta con política de vacaciones");

  if (!vacationType.policy?.id)
    throw new Error("La empresa no cuenta con política de vacaciones");

  return vacationType;
};
